import React from 'react';
import { Button } from 'devextreme-react/button';
import { ToolbarTemplateFileInp } from '../ToolbarTemplateFileInp/ToolbarTemplateFileInp';
import { ToolbarDropDownButton } from '../ToolbarDropDownButton/ToolbarDropDownButton';

export * from './XToolbar.fn';

export const onToolbarPreparing = ({
  e,
  t,
  datagridGridRef,
  rowData,
  setAction,
  action,
  setIsLoadingPanelVisible,
  refreshButton,
  editButton,
  addButton,
  copyButton,
  deleteButton,
  exportButton,
  magnifierButton,
  actionButton,
  exportCount,
  totalCount,
  pageTitle,
  fetchDataTowaryKategorie
}) => {
  const toolbarClickables = [];

  if (refreshButton) {
    toolbarClickables.push({
      visible: refreshButton,
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'refresh',
        hint: `${t('F8')} ${t('Refresh')}`,
        onClick: () => {
          if (fetchDataTowaryKategorie) {
            return fetchDataTowaryKategorie();
          }
          return refreshButton({ dgInstance: datagridGridRef });
        }
      }
    });
  }

  if (addButton) {
    toolbarClickables.push({
      visible: addButton,
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'plus',
        hint: `${t('INS')} ${t('Dodaj')}`,
        onClick: () => addButton({ setAction, action })
      }
    });
  }

  if (editButton) {
    toolbarClickables.push({
      visible: editButton,
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'edit',
        hint: `${t('ENTF4')} ${t('Edytuj')}`,
        onClick: () => editButton({ dgInstance: datagridGridRef, rowData })
      }
    });
  }

  if (magnifierButton) {
    toolbarClickables.push({
      visible: magnifierButton,
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'search',
        hint: `${t('CtrlB')} ${t('Zobacz')}`,
        onClick: () =>
          magnifierButton({
            dgInstance: datagridGridRef,
            rowData
          })
      }
    });
  }

  if (actionButton) {
    let actionFn = actionButton;
    let hint = null;

    if (typeof actionButton === 'object') {
      [actionFn, hint] = actionButton;
    }

    toolbarClickables.push({
      visible: true,
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'runner',
        hint,
        onClick: actionFn ? () => actionFn(datagridGridRef, rowData) : null
      }
    });
  }

  if (deleteButton) {
    toolbarClickables.push({
      visible: deleteButton,
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'trash',
        hint: `${t('DEL')} ${t('Usun')}`,
        onClick: () =>
          deleteButton({
            dgInstance: datagridGridRef,
            rowData
          })
      }
    });
  }

  if (copyButton) {
    toolbarClickables.push({
      visible: copyButton,
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'copy',
        hint: t('DodajNaPodstawieWybranego'),
        onClick: () =>
          copyButton({
            setAction,
            action,
            rowData,
            dgInstance: datagridGridRef
          })
      }
    });
  }

  if (exportButton) {
    toolbarClickables.push({
      visible: exportButton,
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'xlsxfile',
        hint: `${t('CtrlX')} ${t('Eksportuj')}`,
        onClick: () =>
          exportButton({
            dgInstance: datagridGridRef,
            setIsLoadingPanelVisible,
            title: pageTitle
          })
      }
    });
  }

  e.toolbarOptions.items.unshift(
    ...toolbarClickables,
    {
      visible: totalCount,
      location: 'after',
      template: 'additionalActionButton'
    },
    {
      visible: exportCount,
      location: 'after',
      template: 'upload'
    },
    {
      visible: exportCount,
      location: 'after',
      template: 'export'
    },
    {
      visible: totalCount,
      location: 'after',
      template: 'totalGroupCount'
    }
  );
};

export const toolbarItemRender = (
  totalCount,
  themeDark,
  darkCompactTheme,
  lightCompactTheme
) => {
  const isDark = themeDark || darkCompactTheme;
  const isCompact = darkCompactTheme || lightCompactTheme;

  return totalCount ? (
    <div
      className={`informer ${isDark ? '' : 'informer--themeLight'} ${
        isCompact ? 'informer--compact' : ''
      }`}
    >
      <span
        className={`count ${isDark ? '' : 'count--themeLight'} ${
          isCompact ? 'count--compact' : ''
        }`}
      >
        {totalCount}
      </span>
    </div>
  ) : (
    <div style={{ width: '64px' }} />
  );
};

export const toolbarTreeViewButton = (additionalActionButtonData) => {
  return (
    <ToolbarDropDownButton
      additionalActionButtonData={additionalActionButtonData}
      labelTitle={additionalActionButtonData[0].name}
    />
  );
};

export const toolbarImportExcel = (fileHandler) => {
  return (
    <ToolbarTemplateFileInp
      labelTitle="ZaimportujArkusz"
      fileHandler={fileHandler}
    />
  );
};

export const toolbarUploadFiles = (onChange, inpId, t) => (
  <label
    className="datagrid-toolbar-btn-labeled"
    title={t('WgrajFolder')}
    htmlFor={inpId}
  >
    <Button type="normal" stylingMode="contained" icon="upload" />
    <input
      id={inpId}
      type="file"
      webkitdirectory="true"
      directory="true"
      onChange={onChange}
    />
  </label>
);
